<template>
  <section id="contact-1388">
    <div class="cs-container">
      <div class="cs-content">
        <h2 class="cs-title">Get in Touch</h2>
        <p class="cs-text">
          We are a team of compassionate and dedicated professionals committed to delivering personalized, high-quality, and empowering disability support services that enhance independence and well-being.
        </p>
        <ul class="cs-ul">
          <li v-for="contact in contacts" :key="contact.header" class="cs-li">
            <picture class="cs-icon-wrapper">
              <img aria-hidden="true" :src="contact.icon" :alt="contact.alt" class="cs-icon" width="40" height="40" decoding="async">
            </picture>
            <div class="cs-flex-group">
              <span class="cs-header">{{ contact.header }}</span>
              <a v-for="(link, index) in contact.links" :key="index" :href="link.href" target="_blank" rel="noopener noreferrer" class="cs-link">{{ link.text }}</a>
            </div>
          </li>
        </ul>
      </div>
      <!--Form-->
      <form class="cs-form" @submit.prevent="submitForm">
        <h3 class="cs-h3">Make Appointment</h3>
        <label class="cs-label">
          Name
          <input v-model="form.name" class="cs-input" name="name" placeholder="Name">
          <p class="cs-error" v-if="validationErrors.name">{{ validationErrors.name }}</p>
        </label>
        
        <label class="cs-label cs-email">
          Email
          <input v-model="form.email" class="cs-input" name="email" placeholder="Email">
          <p class="cs-error" v-if="validationErrors.email">{{ validationErrors.email }}</p>
        </label>
        
        <label class="cs-label cs-phone">
          Phone
          <div class="cs-phone-wrapper">
            <select v-model="form.countryCode" class="cs-select">
              <option value="+93">🇦🇫 (+93)</option>
  <option value="+355">🇦🇱 (+355)</option>
  <option value="+213">🇩🇿 (+213)</option>
  <option value="+376">🇦🇩 (+376)</option>
  <option value="+244">🇦🇴 (+244)</option>
  <option value="+1-268">🇦🇬 (+1-268)</option>
  <option value="+54">🇦🇷 (+54)</option>
  <option value="+374">🇦🇲 (+374)</option>
  <option value="+61">🇦🇺 (+61)</option>
  <option value="+43">🇦🇹 (+43)</option>
  <option value="+994">🇦🇿 (+994)</option>
  <option value="+1-242">🇧🇸 (+1-242)</option>
  <option value="+973">🇧🇭 (+973)</option>
  <option value="+880">🇧🇩 (+880)</option>
  <option value="+1-246">🇧🇧 (+1-246)</option>
  <option value="+375">🇧🇾 (+375)</option>
  <option value="+32">🇧🇪 (+32)</option>
  <option value="+501">🇧🇿 (+501)</option>
  <option value="+229">🇧🇯 (+229)</option>
  <option value="+975">🇧🇹 (+975)</option>
  <option value="+591">🇧🇴 (+591)</option>
  <option value="+387">🇧🇦 (+387)</option>
  <option value="+267">🇧🇼 (+267)</option>
  <option value="+55">🇧🇷 (+55)</option>
  <option value="+673">🇧🇳 (+673)</option>
  <option value="+359">🇧🇬 (+359)</option>
  <option value="+226">🇧🇫 (+226)</option>
  <option value="+257">🇧🇮 (+257)</option>
  <option value="+855">🇰🇭 (+855)</option>
  <option value="+237">🇨🇲 (+237)</option>
  <option value="+1">🇨🇦 (+1)</option>
  <option value="+238">🇨🇻 (+238)</option>
  <option value="+236">🇨🇫 (+236)</option>
  <option value="+235">🇹🇩 (+235)</option>
  <option value="+56">🇨🇱 (+56)</option>
  <option value="+86">🇨🇳 (+86)</option>
  <option value="+57">🇨🇴 (+57)</option>
  <option value="+269">🇰🇲 (+269)</option>
  <option value="+242">🇨🇬 (+242)</option>
  <option value="+243">🇨🇩 (+243)</option>
  <option value="+682">🇨🇰 (+682)</option>
  <option value="+506">🇨🇷 (+506)</option>
  <option value="+385">🇭🇷 (+385)</option>
  <option value="+53">🇨🇺 (+53)</option>
  <option value="+357">🇨🇾 (+357)</option>
  <option value="+420">🇨🇿 (+420)</option>
  <option value="+45">🇩🇰 (+45)</option>
  <option value="+253">🇩🇯 (+253)</option>
  <option value="+1-767">🇩🇲 (+1-767)</option>
  <option value="+1-809">🇩🇴 (+1-809)</option>
  <option value="+593">🇪🇨 (+593)</option>
  <option value="+20">🇪🇬 (+20)</option>
  <option value="+503">🇸🇻 (+503)</option>
  <option value="+240">🇬🇶 (+240)</option>
  <option value="+291">🇪🇷 (+291)</option>
  <option value="+372">🇪🇪 (+372)</option>
  <option value="+251">🇪🇹 (+251)</option>
  <option value="+679">🇫🇯 (+679)</option>
  <option value="+358">🇫🇮 (+358)</option>
  <option value="+33">🇫🇷 (+33)</option>
  <option value="+241">🇬🇦 (+241)</option>
  <option value="+220">🇬🇲 (+220)</option>
  <option value="+995">🇬🇪 (+995)</option>
  <option value="+49">🇩🇪 (+49)</option>
  <option value="+233">🇬🇭 (+233)</option>
  <option value="+30">🇬🇷 (+30)</option>
  <option value="+1-473">🇬🇩 (+1-473)</option>
  <option value="+502">🇬🇹 (+502)</option>
  <option value="+224">🇬🇳 (+224)</option>
  <option value="+245">🇬🇼 (+245)</option>
  <option value="+592">🇬🇾 (+592)</option>
  <option value="+509">🇭🇹 (+509)</option>
  <option value="+504">🇭🇳 (+504)</option>
  <option value="+36">🇭🇺 (+36)</option>
  <option value="+354">🇮🇸 (+354)</option>
  <option value="+91">🇮🇳 (+91)</option>
  <option value="+62">🇮🇩 (+62)</option>
  <option value="+98">🇮🇷 (+98)</option>
  <option value="+964">🇮🇶 (+964)</option>
  <option value="+353">🇮🇪 (+353)</option>
  <option value="+972">🇮🇱 (+972)</option>
  <option value="+39">🇮🇹 (+39)</option>
  <option value="+1-876">🇯🇲 (+1-876)</option>
  <option value="+81">🇯🇵 (+81)</option>
  <option value="+962">🇯🇴 (+962)</option>
<option value="+7">🇰🇿 (+7)</option>
<option value="+254">🇰🇪 (+254)</option>
<option value="+686">🇰🇮 (+686)</option>
<option value="+850">🇰🇵 (+850)</option>
<option value="+82">🇰🇷 (+82)</option>
<option value="+965">🇰🇼 (+965)</option>
<option value="+996">🇰🇬 (+996)</option>
<option value="+856">🇱🇦 (+856)</option>
<option value="+371">🇱🇻 (+371)</option>
<option value="+961">🇱🇧 (+961)</option>
<option value="+266">🇱🇸 (+266)</option>
<option value="+231">🇱🇷 (+231)</option>
<option value="+218">🇱🇾 (+218)</option>
<option value="+423">🇱🇮 (+423)</option>
<option value="+370">🇱🇹 (+370)</option>
<option value="+352">🇱🇺 (+352)</option>
<option value="+853">🇲🇴 (+853)</option>
<option value="+389">🇲🇰 (+389)</option>
<option value="+261">🇲🇬 (+261)</option>
<option value="+265">🇲🇼 (+265)</option>
<option value="+60">🇲🇾 (+60)</option>
<option value="+960">🇲🇻 (+960)</option>
<option value="+223">🇲🇱 (+223)</option>
<option value="+356">🇲🇹 (+356)</option>
<option value="+692">🇲🇭 (+692)</option>
<option value="+596">🇲🇶 (+596)</option>
<option value="+222">🇲🇷 (+222)</option>
<option value="+230">🇲🇺 (+230)</option>
<option value="+262">🇾🇹 (+262)</option>
<option value="+52">🇲🇽 (+52)</option>
<option value="+691">🇫🇲 (+691)</option>
<option value="+373">🇲🇩 (+373)</option>
<option value="+377">🇲🇨 (+377)</option>
<option value="+976">🇲🇳 (+976)</option>
<option value="+382">🇲🇪 (+382)</option>
<option value="+1664">🇲🇸 (+1664)</option>
<option value="+212">🇲🇦 (+212)</option>
<option value="+258">🇲🇿 (+258)</option>
<option value="+95">🇲🇲 (+95)</option>
<option value="+264">🇳🇦 (+264)</option>
<option value="+674">🇳🇷 (+674)</option>
<option value="+977">🇳🇵 (+977)</option>
<option value="+31">🇳🇱 (+31)</option>
<option value="+687">🇳🇨 (+687)</option>
<option value="+64">🇳🇿 (+64)</option>
<option value="+505">🇳🇮 (+505)</option>
<option value="+227">🇳🇪 (+227)</option>
<option value="+234">🇳🇬 (+234)</option>
<option value="+683">🇳🇺 (+683)</option>
<option value="+672">🇳🇫 (+672)</option>
<option value="+47">🇳🇴 (+47)</option>
<option value="+968">🇴🇲 (+968)</option>
<option value="+92">🇵🇰 (+92)</option>
<option value="+680">🇵🇼 (+680)</option>
<option value="+970">🇵🇸 (+970)</option>
<option value="+507">🇵🇦 (+507)</option>
<option value="+675">🇵🇬 (+675)</option>
<option value="+595">🇵🇾 (+595)</option>
<option value="+51">🇵🇪 (+51)</option>
<option value="+63">🇵🇭 (+63)</option>
<option value="+48">🇵🇱 (+48)</option>
<option value="+351">🇵🇹 (+351)</option>
<option value="+1-787">🇵🇷 (+1-787)</option>
<option value="+974">🇶🇦 (+974)</option>
<option value="+262">🇷🇪 (+262)</option>
<option value="+40">🇷🇴 (+40)</option>
<option value="+7">🇷🇺 (+7)</option>
<option value="+250">🇷🇼 (+250)</option>
<option value="+590">🇧🇱 (+590)</option>
<option value="+290">🇸🇭 (+290)</option>
<option value="+1-869">🇰🇳 (+1-869)</option>
<option value="+1-758">🇱🇨 (+1-758)</option>
<option value="+590">🇲🇫 (+590)</option>
<option value="+508">🇵🇲 (+508)</option>
<option value="+1-784">🇻🇨 (+1-784)</option>
<option value="+685">🇼🇸 (+685)</option>
<option value="+378">🇸🇲 (+378)</option>
<option value="+239">🇸🇹 (+239)</option>
<option value="+966">🇸🇦 (+966)</option>
<option value="+221">🇸🇳 (+221)</option>
<option value="+381">🇷🇸 (+381)</option>
<option value="+248">🇸🇨 (+248)</option>
<option value="+232">🇸🇱 (+232)</option>
<option value="+65">🇸🇬 (+65)</option>
<option value="+421">🇸🇰 (+421)</option>
<option value="+386">🇸🇮 (+386)</option>
<option value="+677">🇸🇧 (+677)</option>
<option value="+252">🇸🇴 (+252)</option>
<option value="+27">🇿🇦 (+27)</option>
<option value="+211">🇸🇸 (+211)</option>
<option value="+34">🇪🇸 (+34)</option>
<option value="+94">🇱🇰 (+94)</option>
<option value="+249">🇸🇩 (+249)</option>
<option value="+597">🇸🇷 (+597)</option>
<option value="+268">🇸🇿 (+268)</option>
<option value="+46">🇸🇪 (+46)</option>
<option value="+41">🇨🇭 (+41)</option>
<option value="+963">🇸🇾 (+963)</option>
<option value="+886">🇹🇼 (+886)</option>
<option value="+992">🇹🇯 (+992)</option>
<option value="+255">🇹🇿 (+255)</option>
<option value="+66">🇹🇭 (+66)</option>
<option value="+228">🇹🇬 (+228)</option>
<option value="+676">🇹🇴 (+676)</option>
<option value="+1-868">🇹🇹 (+1-868)</option>
<option value="+216">🇹🇳 (+216)</option>
<option value="+90">🇹🇷 (+90)</option>
<option value="+993">🇹🇲 (+993)</option>
<option value="+688">🇹🇻 (+688)</option>
<option value="+256">🇺🇬 (+256)</option>
<option value="+380">🇺🇦 (+380)</option>
<option value="+971">🇦🇪 (+971)</option>
<option value="+44">🇬🇧 (+44)</option>
<option value="+1">🇺🇸 (+1)</option>
<option value="+598">🇺🇾 (+598)</option>
<option value="+998">🇺🇿 (+998)</option>
<option value="+678">🇻🇺 (+678)</option>
<option value="+58">🇻🇪 (+58)</option>
<option value="+84">🇻🇳 (+84)</option>
<option value="+681">🇼🇫 (+681)</option>
<option value="+967">🇾🇪 (+967)</option>
<option value="+260">🇿🇲 (+260)</option>
<option value="+263">🇿🇼 (+263)</option>
            </select>
            <input v-model="form.phone" class="cs-input cs-phone-input" name="phone" placeholder="Phone Number">
          </div>
          <p class="cs-error" v-if="validationErrors.phone">{{ validationErrors.phone }}</p>
        </label>
        
        <label class="cs-label">
          Message
          <textarea v-model="form.message" class="cs-input cs-textarea" name="message" placeholder="Write message..."></textarea>
          <p class="cs-error" v-if="validationErrors.message">{{ validationErrors.message }}</p>
        </label>
        
        <label class="cs-checkbox-label">
          <input type="checkbox" v-model="form.consent" name="consent" />
          <span>
            I agree to the
            <router-link to="/privacy-policy" target="_blank">Privacy Policy</router-link>
            and consent to Ajonee storing my information to respond to this enquiry.
          </span>
        </label>
        <p class="cs-error" v-if="validationErrors.consent">{{ validationErrors.consent }}</p>

        <button class="cs-button-solid cs-submit" type="submit" :disabled="loading">{{ loading ? 'Sending...' : 'Send Message' }}</button>
        <p v-if="successMessage" class="cs-success">{{ successMessage }}</p>
        <p v-if="errorMessage" class="cs-error">{{ errorMessage }}</p>
      </form>
    </div>
  </section>
</template>

<script>
export default {
  name: "ContactForm",
  data() {
    return {
      contacts: [
        {
          header: "Phone",
          icon: "https://csimg.nyc3.cdn.digitaloceanspaces.com/Icons/phone-76.svg",
          alt: "phone icon",
          links: [
            { text: "+61-424232426", href: "tel:+61-424232426" },
          ]
        },
        {
          header: "Email",
          icon: "https://csimg.nyc3.cdn.digitaloceanspaces.com/Icons/mail-76.svg",
          alt: "email icon",
          links: [{ text: "info@ajonee.com.au", href: "mailto:info@ajonee.com.au" }]
        },
        {
          header: "Locations",
          icon: "https://csimg.nyc3.cdn.digitaloceanspaces.com/Icons/pin-76.svg",
          alt: "address icon",
          links: [
            { text: "Perth, Western Australia", href: "#" }
          ]
        }
      ],
      form: {
        name: "",
        email: "",
        countryCode: "+61", // default
        phone: "",
        message: "",
        consent: false
      },
      validationErrors: {
        name: "",
        email: "",
        phone: "",
        message: "",
        consent: ""
      },
      loading: false,
      successMessage: "",
      errorMessage: ""
    };
  },
  methods: {
    async submitForm() {
      this.successMessage = "";
      this.errorMessage = "";

      if (!this.validateForm()) {
        return;
      }

      this.loading = true;

      try {
        const payload = {
      ...this.form
      };
        const response = await fetch("https://services.mviaso.com/api/email/send", {
        //const response = await fetch("http://localhost:8080/api/email/send", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            //"x-api-key": "02p9k04i8H0iLvZSDR0zVHCRgwjc8y4Q4BqfcM_s6sI"
          },
          body: JSON.stringify(payload)
        });
        
        if (response.ok) {
          this.successMessage = "Your message has been sent successfully!";
          this.form = { name: "", email: "", phone: "", message: "", consent: false };
        } else {
          this.errorMessage = "Failed to send message. Please try again.";
        }
      } catch (error) {
        this.errorMessage = "An error occurred. Please check your network and try again.";
      } finally {
        this.loading = false;
      }
    },
    validateForm() {
    let valid = true;

    this.validationErrors = {
      name: "",
      email: "",
      phone: "",
      message: "",
      consent: ""
    };

    // Name validation
    if (!this.form.name.trim()) {
      this.validationErrors.name = "Name is required.";
      valid = false;
    } else if (this.form.name.length < 2) {
      this.validationErrors.name = "Name must be at least 2 characters.";
      valid = false;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!this.form.email.trim()) {
      this.validationErrors.email = "Email is required.";
      valid = false;
    } else if (!emailRegex.test(this.form.email)) {
      this.validationErrors.email = "Please enter a valid email address.";
      valid = false;
    }

    // Phone validation
    if (!this.form.phone) {
      this.validationErrors.phone = "Phone number is required.";
      valid = false;
    } else if (!/^[0-9]{7,15}$/.test(this.form.phone)) {
      this.validationErrors.phone = "Please enter a valid phone number.";
      valid = false;
    }else if (this.form.phone.length != 10) {
      this.validationErrors.name = "Phone number must have 10 digits.";
      valid = false;
    }

    // Message validation
    if (!this.form.message.trim()) {
      this.validationErrors.message = "Message is required.";
      valid = false;
    } else if (this.form.message.length < 10) {
      this.validationErrors.message = "Message must be at least 10 characters.";
      valid = false;
    }

    // Consent validation
    if (!this.form.consent) {
      this.validationErrors.consent = "Please agree to the Privacy Policy to continue.";
      valid = false;
    }

    return valid;
  }
  }
};
</script>

<style scoped>

/*-- -------------------------- -->
<---          Contact           -->
<--- -------------------------- -*/

/* Mobile - 360px */
@media only screen and (min-width: 0rem) {
#contact-1388 {
    padding: var(--sectionPadding);
    background: white;
    position: relative;
    z-index: 1;
}
#contact-1388 .cs-container {
    width: 100%;
    /* changes to 1280px at tablet */
    max-width: 36.5rem;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: stretch;
    flex-direction: column;
    column-gap: auto;
    /* 48px - 64px */
    gap: clamp(2rem, 3vw, 3rem);
    position: relative;
}
#contact-1388 .cs-content {
    /* set text align to left if content needs to be left aligned */
    text-align: left;
    width: 100%;
    display: flex;
    flex-direction: column;
    /* centers content horizontally, set to flex-start to left align */
    align-items: flex-start;
}

#contact-1388 .cs-title {
    max-width: 23ch;
}
#contact-1388 .cs-text {
    margin-bottom: 1rem;
}
#contact-1388 .cs-text:last-of-type {
    margin-bottom: 2rem;
}
#contact-1388 .cs-ul {
    text-align: left;
    width: 100%;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1.5rem;
    position: relative;
}
#contact-1388 .cs-li {
    list-style: none;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 1.25rem;
}
#contact-1388 .cs-li:hover .cs-icon-wrapper {
    transform: scale(1.1);
}
#contact-1388 .cs-header {
    font-size: 1.25rem;
    font-weight: 700;
    line-height: 1.2em;
    margin-bottom: 0.75rem;
    color: var(--headerColor);
    display: block;
}
#contact-1388 .cs-link {
    font-size: 1rem;
    line-height: 1.5em;
    text-decoration: none;
    color: #767676;
    display: block;
    position: relative;
}
#contact-1388 .cs-link:hover {
    text-decoration: underline;
}
#contact-1388 .cs-icon-wrapper {
    width: 3.75rem;
    height: 3.75rem;
    margin: 0;
    border-radius: 50%;
    border: 1px solid #bababa;
    display: flex;
    justify-content: center;
    align-items: center;
    /* prevents flexbox from squishing it */
    flex: none;
    transition: transform 0.3s;
}
#contact-1388 .cs-icon {
    width: 1.5rem;
    height: auto;
    display: block;
}
#contact-1388 .cs-form {
    width: 100%;
    max-width: 39.375rem;
    /* 24px - 48px top and bottom */
    /* 16px - 48px left and right */
    padding: clamp(1.5rem, 5.18vw, 3rem) clamp(1rem, 4vw, 3rem);
    /* prevents flexbox from affecting height and width */
    box-sizing: border-box;
    /*background-color: #fff;*/
    border-radius: 1rem;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.75rem;
    border: clamp(1px, 1vw, 1px) solid var(--primary);
}
#contact-1388 .cs-h3 {
    /* 20px - 39px */
    font-size: clamp(1.25rem, 3vw, 2.4375rem);
    line-height: 1.2em;
    font-weight: 700;
    margin: 0 0 0.25rem 0;
    color: var(--headerColor);
}
#contact-1388 .cs-label {
    /* 14px - 16px */
    font-size: clamp(0.875rem, 1.5vw, 1rem);
    width: 100%;
    color: var(--headerColor);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 0.25rem;
}
#contact-1388 .cs-input {
    font-size: 1rem;
    width: 100%;
    height: 3.5rem;
    padding: 0;
    padding-left: 1.5rem;
    color: var(--headerColor);
    background-color: #f7f7f7;
    border-radius: 0.5rem;
    border: clamp(1px, 1vw, 1px) solid var(--primary);
    /* prevents padding from adding to height and width */
    box-sizing: border-box;
}
#contact-1388 .cs-input::placeholder {
    color: #7d799c;
    opacity: 0.6;
}

#contact-1388 .cs-checkbox-label {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  font-size: 0.875rem;
  line-height: 1.5em;
  color: var(--bodyTextColor);
  width: 100%;
}
#contact-1388 .cs-checkbox-label input[type="checkbox"] {
  margin-top: 0.2rem;
  width: 1.1rem;
  height: 1.1rem;
  flex-shrink: 0;
  accent-color: var(--primary);
}
#contact-1388 .cs-checkbox-label a {
  color: var(--secondary);
  font-weight: 700;
}

#contact-1388 .cs-phone-wrapper {
  display: flex;
  width: 100%;
  gap: 0.5rem;
}

#contact-1388 .cs-select {
  font-size: 1rem;
  padding: 0 1rem;
  height: 3.5rem;
  background-color: #f7f7f7;
  border: clamp(1px, 1vw, 1px) solid var(--primary);
  border-radius: 0.5rem;
  color: var(--headerColor);
  flex: 0 0 6rem;
  box-sizing: border-box;
}

#contact-1388 .cs-phone-input {
  flex: 1;
}

#contact-1388 .cs-textarea {
    min-height: 7.5rem;
    padding-top: 1.5rem;
    margin-bottom: 0.75rem;
    font-family: inherit;
}
#contact-1388 .cs-button-solid {
    font-size: 1rem;
    line-height: 3.5rem;
    text-decoration: none;
    font-weight: 700;
    overflow: hidden;
    margin: 0;
    color: #fff;
    padding: 0 3rem;
    border-radius: 1.875rem;
    background-color: var(--primary);
    display: inline-block;
    position: relative;
    z-index: 1;
    transition: color 0.3s;
}
#contact-1388 .cs-button-solid:before {
    content: "";
    position: absolute;
    display: block;
    height: 100%;
    width: 0%;
    background: #1a1a1a;
    opacity: 1;
    top: 0;
    left: 0;
    z-index: -1;
    transition: width 0.3s;
}
#contact-1388 .cs-button-solid:hover {
    color: var(--primary);
}
#contact-1388 .cs-button-solid:hover:before {
    width: 100%;
}
#contact-1388 .cs-submit {
    width: 100%;
    min-width: 12.5rem;
    border: none;
}
#contact-1388 .cs-submit:hover {
    color: #fff;
    cursor: pointer;
}
.cs-error {
  color: #e53935; /* red shade */
  font-size: 0.875rem;
  margin-top: 0.25rem;
}
}
/* Tablet - 768px */
@media only screen and (min-width: 48rem) {
#contact-1388 .cs-container {
    max-width: 80rem;
    flex-direction: row;
    justify-content: space-between;
}
#contact-1388 .cs-content {
    width: 47%;
    /* prevents flexbox from squishing it */
    flex: none;
}
#contact-1388 .cs-submit {
    width: auto;
}
}
/* Desktop - 1024px */
@media only screen and (min-width: 64rem) {
#contact-1388 .cs-form {
    width: 46%;
    max-width: 36.125rem;
}
#contact-1388 .cs-submit {
    width: auto;
}
}
/* Large Desktop - 1500px */
@media only screen and (min-width: 93.75rem) {
#contact-1388 .cs-graphic {
    display: block;
}
}

</style>